'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { REQUESTED_MAB_PAST_EXPERIMENTS } from '../actions/ActionTypes';
import { requestMABPastExperimentsFailed, requestMABPastExperimentsSucceeded } from '../actions/MABActions';
export default ((action$, _, {
  MABClient
}) => action$.ofType(REQUESTED_MAB_PAST_EXPERIMENTS).pipe(mergeMap(({
  payload: {
    contentId,
    contentType
  }
}) => MABClient.fetchPastExperiments(contentId, contentType).pipe(map(requestMABPastExperimentsSucceeded), catchError(error => of(requestMABPastExperimentsFailed(error)))))));